<ng-container *ngIf="isVisible">
    <div class="action-footer">
        <ng-container *ngFor="let button of actions">
            <ion-button expand="block" [fill]="button.type" (click)="doAction(button)" [disabled]="button.disabled || false">
                <ng-container *ngIf="button.icon">
                    <ion-icon [name]="button.icon" style="margin-right: 8px;"></ion-icon>
                </ng-container>
                {{ button.name | translate }}
            </ion-button>
        </ng-container>
    </div>
</ng-container>
